namespace Nobox {
    @Serenity.Decorators.registerFormatter()
    export class MsgConversationFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            if (Q.isEmptyOrNull(ctx.value))
                return "";

            var msg = ctx.value, iconMsg="";
            if (msg.includes('<i class="fa fa-image"></i>')) {
                msg = msg.replace('<i class="fa fa-image"></i> ', '');
                iconMsg = '<i class="fa fa-image"></i>';
            } else if (msg.includes("<i class='fa fa-image'></i>")) {
                msg = msg.replace("<i class='fa fa-image'></i> ", '');
                iconMsg = '<i class="fa fa-image"></i>';
            } else if (msg.includes('<i class="fa fa-file"></i>')) {
                msg = msg.replace('<i class="fa fa-file"></i> ', '');
                iconMsg = '<i class="fa fa-file"></i>';
            } else if (msg.includes("<i class='fa fa-file'></i>")) {
                msg = msg.replace("<i class='fa fa-file'></i> ", '');
                iconMsg = '<i class="fa fa-file"></i>';
            } else if (msg.includes('<i class="fa fa-microphone"></i>')) {
                msg = msg.replace('<i class="fa fa-microphone"></i>', '');
                iconMsg = '<i class="fa fa-microphone"></i>';
            } else if (msg.includes("<i class='fa fa-microphone'></i>")) {
                msg = msg.replace("<i class='fa fa-microphone'></i> ", '');
                iconMsg = '<i class="fa fa-microphone"></i>';
            } else if (msg.includes('<i class="fa fa-video"></i>')) {
                msg = msg.replace('<i class="fa fa-video"></i>', '');
                iconMsg = '<i class="fa fa-video"></i>';
            } else if (msg.includes("<i class='fa fa-video'></i>")) {
                msg = msg.replace("<i class='fa fa-video'></i> ", '');
                iconMsg = '<i class="fa fa-video"></i>';
            } else if (msg.includes("<i class='fa fa-sticky-note'></i>")) {
                msg = msg.replace("<i class='fa fa-sticky-note'></i> ", '');
                iconMsg = '<i class="fa fa-sticky-note"></i>';
            }
            return iconMsg +" "+ msg;
        }
    }
}